import { createSlice } from "@reduxjs/toolkit";
import { GetBOPPropertyDetailsFormJson, GetBOPBuildingSafetyFeaturesFormJson, GetBOPUsageAndOccupancyFormJson } from "./BOPPolicyChangeActions";

interface IBOPPolicyChangeSlice {
  bopPropertyDetailsFormFieldsJson: any | null;
  bopBuildingSafetyFeaturesFormFieldsJson: any | null;
  bopUsageAndOccupancyFormFieldsJson: any | null;
}

const initialState: IBOPPolicyChangeSlice = {
  bopPropertyDetailsFormFieldsJson: null,
  bopBuildingSafetyFeaturesFormFieldsJson: null,
  bopUsageAndOccupancyFormFieldsJson: null,
};

const bopPolicyChangeSlice = createSlice({
  name: "bopPolicyChange",
  initialState: initialState,
  reducers: {
    setBOPPropertyDetailsFormFieldsJson: (state, { payload }) => {
      state.bopPropertyDetailsFormFieldsJson = payload;
    },
    setBOPBuildingSafetyFeaturesFormFieldsJson: (state, { payload }) => {
      state.bopBuildingSafetyFeaturesFormFieldsJson = payload;
    },
    setBOPUsageAndOccupancyFormFieldsJson: (state, { payload }) => {
      state.bopUsageAndOccupancyFormFieldsJson = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      GetBOPPropertyDetailsFormJson.fulfilled,
      (state, { payload }) => {
        state.bopPropertyDetailsFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
    builder.addCase(
      GetBOPBuildingSafetyFeaturesFormJson.fulfilled,
      (state, { payload }) => {
        state.bopBuildingSafetyFeaturesFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
    builder.addCase(
      GetBOPUsageAndOccupancyFormJson.fulfilled,
      (state, { payload }) => {
        state.bopUsageAndOccupancyFormFieldsJson =
          payload.status === "SUCCESS" ? payload.data : null;
      }
    );
  },
});

export default bopPolicyChangeSlice.reducer;
export const { setBOPPropertyDetailsFormFieldsJson, setBOPBuildingSafetyFeaturesFormFieldsJson, setBOPUsageAndOccupancyFormFieldsJson } = bopPolicyChangeSlice.actions; 